'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var SimpleHepGridController = function SimpleHepGridController($scope, dataRetrieverService, dataRetrieverConstantsService, configurationParametersRenderersFactory, hepService, hepSimpleService, $log) {
  $scope.customRenderers = configurationParametersRenderersFactory;
  $scope.showSimpleGrid = true;
  var HEP_SIMPLE_TYPE = {
    'Revenue Optimizer': 'RevenueOptimizer',
    'Fares Optimizer': 'FaresOptimizer',
    'Dynamic Availability': 'DynamicAvailability'
  };
  var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_MODE);
  function changeGridSettingsAndGetData() {
    $scope.showSimpleGrid = false;
    dataRetriever.selectedParams({
      type: HEP_SIMPLE_TYPE[$scope.selected.hierarchy]
    });
    $scope.simpleHepSettings = {
      type: HEP_SIMPLE_TYPE[$scope.selected.hierarchy]
    };
  }
  function refreshGridSettingsDynamically() {
    $scope.showSimpleGrid = true;
  }
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_MODE).setCustomSearchCriteriaRules([]);
  function prepareSimpleHepProperties(rows, simpleHepProperties) {
    var hepClone = _.clone(simpleHepProperties);
    _.forEach(rows, function (element) {
      var value;
      switch (element.propertyType) {
        case 'boolean':
          value = element.propertyValue.toLocaleLowerCase() !== 'false';
          break;
        case 'number':
          value = _.toNumber(element.propertyValue);
          break;
        default:
          value = element.propertyValue;
      }
      if (element.propertyType === 'number' && (isNaN(value) || !isFinite(value))) {
        $log.error('ConfigurationParametersSimpleController: prepareSimpleHapProperties - Validation Error');
        toastr.error('Validation Error');
      }
      if (element.customControlType === 'maskedinput') {
        value = configurationParametersRenderersFactory.parseMaskTimeValue(value);
      } else {
        value = configurationParametersRenderersFactory.parseValue(element.propertyName, value);
      }
      hepClone[element.propertyName] = value;
    });
    return hepClone;
  }
  function simpleHepSave(event, rows) {
    var simpleHepProperties = hepService.retrieveSimpleHepProperties();
    var data = prepareSimpleHepProperties(rows, simpleHepProperties);
    var hepType = HEP_SIMPLE_TYPE[$scope.selected.hierarchy];
    hepSimpleService.saveSimpleHepProperties(data, hepType).then(function () {
      $scope.$broadcast('configuration-parameters-simple:saveSuccess');
      if (hepType === 'DynamicAvailability') {
        hepService.loadFeatureSpecificSimpleHeps();
      }
    });
  }
  $scope.$on('configuration-parameters-simple:saveChanges', simpleHepSave);
  $scope.$on('configuration-parameters-simple:validationErrorOnSave', function () {
    $log.error('ConfigurationParametersSimpleController: configuration-parameters-simple:validationErrorOnSave - Validation Error');
    toastr.error('Validation Error');
  });
  $scope.$watch('simpleHepSettings', refreshGridSettingsDynamically);
  $scope.$watch('selected', changeGridSettingsAndGetData, true);
};
SimpleHepGridController.$inject = ['$scope', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ConfigurationParametersRenderersFactory', 'HepService', 'HepSimpleService', '$log'];
module.exports = SimpleHepGridController;